// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntd[data-v-5d5f678f] \n{\n\tvertical-align: middle;\n}\n.table th[data-v-5d5f678f] {\n\tvertical-align: middle;\n}\ntr[data-v-5d5f678f]:hover {\n\tcursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
